// Custom SVG icons for customer type classification
// Reseller = 2 helium atoms connected (He-He bond representation)
// Dealer = H2O molecule (bent, central O + 2 H — chemistry-textbook style)
// OEM = large gear driving a small gear

export function HeliumDimer({ size = 16, className = "" }) {
  // Two bonded He atoms, rendered left→right with bond line between
  const s = size;
  return (
    <svg viewBox="0 0 32 20" width={s * 1.6} height={s} className={className} fill="none" stroke="currentColor" strokeLinecap="round">
      {/* Bond line */}
      <line x1="10" y1="10" x2="22" y2="10" strokeWidth="1.5" />
      {/* Left atom */}
      <circle cx="8" cy="10" r="6" fill="currentColor" stroke="none" />
      <text x="8" y="12.5" textAnchor="middle" fontSize="6.5" fontWeight="bold" fill="white" stroke="none" fontFamily="sans-serif">He</text>
      {/* Right atom */}
      <circle cx="24" cy="10" r="6" fill="currentColor" stroke="none" />
      <text x="24" y="12.5" textAnchor="middle" fontSize="6.5" fontWeight="bold" fill="white" stroke="none" fontFamily="sans-serif">He</text>
    </svg>
  );
}

export function WaterMolecule({ size = 16, className = "" }) {
  // Textbook H-O-H bent molecule. Central oxygen, 2 hydrogens at ~104° bond angle.
  const s = size;
  return (
    <svg viewBox="0 0 28 22" width={s * 1.4} height={s * 1.1} className={className} fill="none" stroke="currentColor" strokeLinecap="round">
      {/* O-H bonds (meeting the oxygen center at angles) */}
      <line x1="14" y1="14" x2="6.5" y2="7" strokeWidth="1.4" />
      <line x1="14" y1="14" x2="21.5" y2="7" strokeWidth="1.4" />
      {/* Central oxygen (large) */}
      <circle cx="14" cy="14" r="5.2" fill="currentColor" stroke="none" />
      <text x="14" y="16.3" textAnchor="middle" fontSize="6" fontWeight="bold" fill="white" stroke="none" fontFamily="sans-serif">O</text>
      {/* Two hydrogens (smaller, lighter) */}
      <circle cx="6.5" cy="7" r="3.3" fill="currentColor" opacity="0.75" stroke="none" />
      <text x="6.5" y="8.7" textAnchor="middle" fontSize="4" fontWeight="bold" fill="white" stroke="none" fontFamily="sans-serif">H</text>
      <circle cx="21.5" cy="7" r="3.3" fill="currentColor" opacity="0.75" stroke="none" />
      <text x="21.5" y="8.7" textAnchor="middle" fontSize="4" fontWeight="bold" fill="white" stroke="none" fontFamily="sans-serif">H</text>
    </svg>
  );
}

export function GearsIcon({ size = 16, className = "" }) {
  // Large gear (left) meshed with small gear (right) — OEM = original equipment manufacturer.
  // Simple 8-tooth large + 6-tooth small approximated via star paths.
  return (
    <svg viewBox="0 0 32 22" width={size * 1.5} height={size * 1.05} className={className} fill="currentColor">
      {/* Large gear (left) */}
      <g transform="translate(10 11)">
        {/* 8 teeth as a rotated rounded cross */}
        <g>
          {[0, 45, 90, 135].map((deg) => (
            <rect key={deg} x="-1.5" y="-8.5" width="3" height="17" rx="0.6" transform={`rotate(${deg})`} />
          ))}
        </g>
        <circle r="6" />
        <circle r="2.2" fill="white" />
      </g>
      {/* Small gear (right) */}
      <g transform="translate(25 6)">
        {[0, 60, 120].map((deg) => (
          <rect key={deg} x="-1" y="-5.2" width="2" height="10.4" rx="0.5" transform={`rotate(${deg})`} />
        ))}
        <circle r="3.5" />
        <circle r="1.3" fill="white" />
      </g>
    </svg>
  );
}

// Return metadata based on Customer.Type, or null to show no icon (e.g. EndUser).
export function customerTypeIcon(type) {
  if (!type) return null;
  const t = String(type).toLowerCase();
  if (t.includes("reseller")) {
    return { Icon: HeliumDimer, title: "Reseller", color: "text-purple-600" };
  }
  if (t.includes("oem")) {
    return { Icon: GearsIcon, title: "OEM", color: "text-amber-600" };
  }
  if (t.includes("dealer") || t.includes("distributor")) {
    return { Icon: WaterMolecule, title: t.includes("distributor") ? "Distributor" : "Dealer", color: "text-sky-600" };
  }
  return null;
}
